/**
 * Owner: Masa Bayu
 * File: account-gate.ts
 * Date:Time: 2026-09-28 10:30
 * Description: Account/Profile/QXEditor open only after a QXRead hub session. Otherwise sign-in.
 */

export function safeAccountReturnTo(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const path = raw.trim();
  if (/^https?:\/\//i.test(path)) return null;
  if (!path.startsWith('/') || path.startsWith('//')) return null;
  if (path.includes('://')) return null;
  if (path.startsWith('/login')) return null;
  return path;
}

export function accountEntryPath(signedIn: boolean, returnTo = '/account'): string {
  const safe = safeAccountReturnTo(returnTo) ?? '/account';
  if (signedIn) return safe.startsWith('/account') ? safe : '/account';
  return `/login?returnTo=${encodeURIComponent(safe)}`;
}

/** Paths that must not render without a QXRead hub session. */
export function isAccountPath(path: string): boolean {
  if (path === '/account' || path === '/profile') return true;
  return path.startsWith('/account/') || path.startsWith('/profile/');
}

/** Wait for session hydrate before login vs editor — avoids deploy/refresh login flash. */
export function editorSessionPhase(
  sessionReady: boolean,
  hasAccount: boolean,
): 'checking' | 'login' | 'open' {
  if (!sessionReady) return 'checking';
  return hasAccount ? 'open' : 'login';
}
